import React, { useCallback, useEffect } from 'react'
import { batch, useSelector } from 'react-redux'
import styles from './VacancyManagerTemplatesList.module.scss'
import VacancyManagerTemplatesListItem from './VacancyManagerTemplatesListItem'
import { useDispatch } from 'react-redux'
import { editTemplate, setTemplateType, setIsButtonEnable, clearTemplateForm, hardDeleteTemplate } from '../../../../redux/vacancyManager/vacancyManager.action'
import { confirm } from '../../../../UI/Confirm/Confirm'

const VacancyManagerTemplatesList = ({ handleScroll }) => {
    const dispatch = useDispatch()
    const { inEditId: currentInEdit, templateList } = useSelector(({ vacancies }) => vacancies)

    const handleEditClick = useCallback((id, vacancy_type, template_type, isOnEdit) => {
        dispatch(setTemplateType(template_type))
        if (isOnEdit) {
            dispatch(clearTemplateForm())
            return
        }
        batch(() => {
            dispatch(editTemplate(id, vacancy_type, template_type))
            dispatch(setIsButtonEnable(false))
        })
    }, [dispatch])
    
    const handleDeleteClick = useCallback((id) => {
        confirm('Are you sure?', 'You want to delete this template? (forever)', () => {
          batch(() => {
            dispatch(hardDeleteTemplate(id))
            dispatch(clearTemplateForm())
          })    
        })
        // eslint-disable-next-line
      }, [])

    useEffect(() => {
        dispatch(clearTemplateForm())
        return () => dispatch(clearTemplateForm())
    }, [templateList, dispatch])

    return (
        <div className={styles.list} onScroll={handleScroll}>
            {templateList.map((item) => (
                <VacancyManagerTemplatesListItem
                    key={item.id}
                    data={item}
                    onDeleteClick={handleDeleteClick}
                    onEditClick={handleEditClick}
                    isOnEdit={item.id === currentInEdit}
                />
            ))}
        </div>
    )
}

export default VacancyManagerTemplatesList